<header class="farachat-topbar h-16">
  <div
    class="flex items-center h-full relative z-100 bg-neutral-800 border-b border-neutral-700/30"
  >
    <div class="flex items-center space-x-2 h-full ps-0 lg:min-w-80 relative">
      <!-- Hamburger Menu Button (Mobile Only) -->
      <button
        (click)="toggleMobileMenu()"
        class="lg:hidden p-1 rounded-lg w-8 h-8 bg-neutral-700/70 hover:bg-neutral-600/90 dark:hover:bg-neutral-600/90 transition-all duration-200 flex items-center justify-center ms-3 xl:ms-0"
        [attr.aria-label]="'header.menu' | transloco"
      >
        <i [class]="isMobileMenuOpen ? 'pi pi-times' : 'pi pi-bars'" class="text-white text-lg"></i>
      </button>
      <!-- <div
        class="w-8 h-8 bg-gradient-to-tr from-primary-500 to-primary-600 rounded-lg flex items-center justify-center">
        <i class="pi pi-comment text-white cursor-pointer" routerLink="/chat"></i>
      </div> -->
      <span class="text-lg lg:text-xl font-bold text-white cursor-pointer" routerLink="/">
        {{ 'header.siteName' | transloco }}
      </span>
    </div>
    <div
      class="flex-1 flex items-center justify-end lg:justify-between h-full lg:ps-3 pe-3 lg:pe-6 relative"
    >
      <!-- Desktop Navigation -->
      <nav class="hidden lg:flex items-center space-x-1">
        @for (item of navItems; track $index) {
          @if (item.resourceName === 'Team') {
            <!-- Teams Button with Dropdown -->
            <div class="relative">
              <button
                [class.active]="isTeamsRoute()"
                (click)="toggleTeamsPopover($event)"
                [permission]="item.resourceName + ':' + 'read'"
                [fallback]="'hidden'"
                [resourceType]="'menu'"
                class="flex items-center cursor-pointer space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200"
                [ngClass]="
                  isTeamsRoute()
                    ? 'bg-primary-300/20 text-primary-300'
                    : 'text-neutral-300 hover:bg-neutral-700/50 hover:text-white'
                "
              >
                <i [class]="item.iconClass + ' w-4 h-4'"></i>
                <span>{{ item.labelKey | transloco }}</span>
                <i class="pi pi-chevron-down w-3 h-3" style="font-size: 10px;"></i>
              </button>
              <p-popover #teamsPopover styleClass="teams-popover">
                <div class="w-48">
                  <button
                    (click)="navigateToTeamsGridView()"
                    class="w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-neutral-200 dark:hover:bg-neutral-700/50 text-neutral-700 dark:text-neutral-300"
                    [ngClass]="
                      activeMenuItem === '/ai-agent/teams' || activeMenuItem.includes('/ai-agent/teams/')
                        ? 'bg-primary-300/20 text-primary-300 dark:text-primary-300'
                        : ''
                    "
                  >
                    <i class="pi pi-th-large w-4 h-4"></i>
                    <span>{{ 'header.nav.teams.gridView' | transloco }}</span>
                  </button>
                  <button
                    (click)="navigateToTeamsTreeView()"
                    class="w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 hover:bg-neutral-200 dark:hover:bg-neutral-700/50 text-neutral-700 dark:text-neutral-300 mt-1"
                    [ngClass]="
                      activeMenuItem === '/ai-agent/teams-tree'
                        ? 'bg-primary-300/20 text-primary-300 dark:text-primary-300'
                        : ''
                    "
                  >
                    <i class="pi pi-sitemap w-4 h-4"></i>
                    <span>{{ 'header.nav.teams.treeView' | transloco }}</span>
                  </button>
                </div>
              </p-popover>
            </div>
          } @else {
            <button
              [class.active]="activeMenuItem.includes(item.route)"
              (click)="navigateToRoute(item.route)"
              [routerLink]="item.route"
              [permission]="item.resourceName + ':' + 'read'"
              [fallback]="'hidden'"
              [resourceType]="'menu'"
              class="flex items-center cursor-pointer space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200"
              [ngClass]="
                activeMenuItem.includes(item.route)
                  ? 'bg-primary-300/20 text-primary-300'
                  : 'text-neutral-300 hover:bg-neutral-700/50 hover:text-white'
              "
            >
              <i [class]="item.iconClass + ' w-4 h-4'"></i>
              <span>{{ item.labelKey | transloco }}</span>
            </button>
          }
        }
      </nav>

      <div class="flex items-center space-x-2 lg:space-x-0 xl:space-x-4">
        <!-- Theme Toggle -->
        <button
          (click)="toggleTheme()"
          class="p-0 lg:hidden rounded-xl w-8 h-8 bg-neutral-700/70 dark:bg-neutral-700/70 hover:bg-neutral-600/90 dark:hover:bg-neutral-600/90 transition-all duration-200 flex items-center justify-center lg:hidden"
          [attr.aria-label]="
            isDark
              ? ('header.theme.switchToLight' | transloco)
              : ('header.theme.switchToDark' | transloco)
          "
        >
          @if (isDark) {
            <i class="pi pi-sun text-amber-300"></i>
          } @else {
            <i class="pi pi-moon text-neutral-300 dark:text-neutral-300"></i>
          }
        </button>

        <!-- User Avatar with Popover -->
        @if (currentUser) {
          <div class="relative">
            <button
              (click)="toggleUserPopover($event)"
              class="p-0 rounded-xl w-8 h-8 bg-neutral-700/70 dark:bg-neutral-700/70 hover:bg-neutral-600/90 dark:hover:bg-neutral-600/90 transition-all duration-200 flex items-center justify-center overflow-hidden lg:hidden"
            >
              <p-avatar
                [image]="currentUser?.picture"
                [label]="currentUser.picture? null : currentUser?.username?.charAt(0)?.toUpperCase() || 'U'"
                size="normal"
                class="w-full h-full avatar-image"
                [style]="{ backgroundColor: 'transparent', color: 'var(--color-pink-500)' }"
              >
              </p-avatar>
            </button>

            <p-popover #userPopover styleClass="topbar-user-popover">
              <app-user-popover
                [currentUser]="currentUser"
                [currentUserBalance]="currentUserBalance"
                [balanceLoading]="balanceLoading"
                [isDark]="isDark"
                [currentLanguage]="currentLanguage"
                [availableLanguages]="availableLanguages"
                [appVersion]="appVersion"
                [userPopoverRef]="userPopover"
                (languageSelect)="onLanguageSelect($event)"
                (logoutClick)="onLogoutClick()"
              ></app-user-popover>
            </p-popover>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Mobile Navigation Menu -->
  <div
    [class.hidden]="!isMobileMenuOpen"
    style="pointer-events: auto"
    class="lg:hidden absolute top-16 start-0 end-0 bg-neutral-800/95 dark:bg-neutral-800/95 z-40 transition-all duration-300"
  >
    <nav class="flex flex-col p-4 space-y-2 min-h-[100vh]">
      @for (item of navItems; track $index) {
        @if (item.resourceName === 'Team') {
          <!-- Teams Button with Dropdown in Mobile -->
          <div class="flex flex-col space-y-1">
            <button
              [class.active]="isTeamsRoute()"
              (click)="isTeamsMenuOpen = !isTeamsMenuOpen"
              [permission]="item.resourceName + ':' + 'read'"
              [fallback]="'hidden'"
              [resourceType]="'menu'"
              class="flex items-center cursor-pointer space-x-3 px-4 py-3 rounded-lg text-base font-medium transition-all duration-200 w-full"
              [ngClass]="
                isTeamsRoute()
                  ? 'bg-primary-300/20 dark:bg-primary-300/20 text-primary-300 dark:text-primary-300'
                  : 'text-neutral-300 dark:text-neutral-300 hover:bg-neutral-700/50 dark:hover:bg-neutral-700/50 hover:text-white dark:hover:text-white'
              "
            >
              <i [class]="item.iconClass + ' w-5 h-5'"></i>
              <span class="me-auto">{{ item.labelKey | transloco }}</span>
              <i [class]="'pi w-4 h-4 transition-transform duration-200 ' + (isTeamsMenuOpen ? 'pi-chevron-up' : 'pi-chevron-down')"></i>
            </button>
            @if (isTeamsMenuOpen) {
              <div class="flex flex-col space-y-1 ms-8">
                <button
                  (click)="navigateToTeamsGridView(); toggleMobileMenu()"
                  class="flex items-center cursor-pointer space-x-3 px-4 py-3 rounded-lg text-base font-medium transition-all duration-200 w-full"
                  [ngClass]="
                    activeMenuItem === '/ai-agent/teams' || activeMenuItem.includes('/ai-agent/teams/')
                      ? 'bg-primary-300/20 dark:bg-primary-300/20 text-primary-300 dark:text-primary-300'
                      : 'text-neutral-300 dark:text-neutral-300 hover:bg-neutral-700/50 dark:hover:bg-neutral-700/50 hover:text-white dark:hover:text-white'
                  "
                >
                  <i class="pi pi-th-large w-5 h-5"></i>
                  <span>{{ 'header.nav.teams.gridView' | transloco }}</span>
                </button>
                <button
                  (click)="navigateToTeamsTreeView(); toggleMobileMenu()"
                  class="flex items-center cursor-pointer space-x-3 px-4 py-3 rounded-lg text-base font-medium transition-all duration-200 w-full"
                  [ngClass]="
                    activeMenuItem === '/ai-agent/teams-tree'
                      ? 'bg-primary-300/20 dark:bg-primary-300/20 text-primary-300 dark:text-primary-300'
                      : 'text-neutral-300 dark:text-neutral-300 hover:bg-neutral-700/50 dark:hover:bg-neutral-700/50 hover:text-white dark:hover:text-white'
                  "
                >
                  <i class="pi pi-sitemap w-5 h-5"></i>
                  <span>{{ 'header.nav.teams.treeView' | transloco }}</span>
                </button>
              </div>
            }
          </div>
        } @else {
          <button
            [class.active]="activeMenuItem.includes(item.route)"
            (click)="navigateToRoute(item.route); toggleMobileMenu()"
            [routerLink]="item.route"
            [permission]="item.resourceName + ':' + 'read'"
            [fallback]="'hidden'"
            [resourceType]="'menu'"
            class="flex items-center cursor-pointer space-x-3 px-4 py-3 rounded-lg text-base font-medium transition-all duration-200 w-full"
            [ngClass]="
              activeMenuItem.includes(item.route)
                ? 'bg-primary-300/20 dark:bg-primary-300/20 text-primary-300 dark:text-primary-300'
                : 'text-neutral-300 dark:text-neutral-300 hover:bg-neutral-700/50 dark:hover:bg-neutral-700/50 hover:text-white dark:hover:text-white'
            "
          >
            <i [class]="item.iconClass + ' w-5 h-5'"></i>
            <span>{{ item.labelKey | transloco }}</span>
          </button>
        }
      }
    </nav>
  </div>
</header>
